import * as Yup from "yup";

export const contactValidation = Yup.object().shape({
  from_name: Yup.string()
    .matches(
      /^[a-zA-Z ]*$/,
      "Your name can not contain numbers...Please try again"
    )
    .min(2, "Your name must contain more than 1 letter. Please try again")
    .required("Your name is required"),
  reply_to: Yup.string()
    .email("Email address is not valid...Please try again")
    .required("An email is required"),
  message: Yup.string()
    .min(5, "Your message is missing some substance...Please try again")
    .required("A message is required"),
});
